import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

export const ExtractPersonalizedOfferRequest = z.object({
  calibrationId: z.string().uuid(),
  brandUrl: z.string().url(),
})

export type ExtractPersonalizedOfferRequest = z.infer<typeof ExtractPersonalizedOfferRequest>

export const ExtractPersonalizedOfferResponse = z.object({
  /** personalizedProduct is an object that contains the product name and product url */
  personalizedProduct: z.object({
    productName: z.string(),
    productImageUrl: z.string(),
    productUrl: z.string(),
  }),
  /** brandScreenshot is a url to the brand screenshot */
  brandScreenshot: z.string(),
})

export type ExtractPersonalizedOfferResponse = z.infer<typeof ExtractPersonalizedOfferResponse>

export const extractPersonalizedOfferDeclaration = endpointDeclaration(
  ExtractPersonalizedOfferRequest,
  ExtractPersonalizedOfferResponse,
)
